module.exports = __webpack_public_path__ + "static/img/hangyeli1.21c7f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/hangyeli1.png
// module id = oZ+Y
// module chunks = 5